const cart = [
  {
    path: "/cart",
    name: "/cart",
    component: () => import("@/views/CartPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "Cart" },
  },
  {
    path: "/cart/checkout",
    name: "/cart/checkout",
    component: () => import("@/views/CartCheckoutPage.vue"),
    meta: { requiresAuth: false, layout: "Main", title: "Checkout" },
    beforeEnter: () => {
      if (typeof window !== "undefined") {
        //@ts-ignore
        window.dataLayer = window.dataLayer || []
        //@ts-ignore
        window.dataLayer.push({
          event: "begin_checkout",
        })
      }
    },
  },
  {
    path: "/stripe",
    name: "stripe",
    component: () => import("@/views/PageStripe.vue"),
    meta: {
      availableInIframe: true,
      requiresAuth: false,
      layout: "Main",
      title: "Stripe",
    },
  },
]

export { cart }
